import { render } from "./HeadingText.vue?vue&type=template&id=166dc44e&scoped=true"
import script from "./HeadingText.vue?vue&type=script&lang=js"
export * from "./HeadingText.vue?vue&type=script&lang=js"

import "./HeadingText.vue?vue&type=style&index=0&id=166dc44e&scoped=true&lang=css"

import exportComponent from "C:\\4 Websites\\enfinity\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166dc44e"]])

export default __exports__